export function decodeTokenPayload(token: string): { tenantId: string; customerId: string; expiry: number; customerName: string | null } | null {
  try {
    const dot = token.indexOf('.');
    if (dot < 1) return null;
    const b64 = token.slice(0, dot).replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - b64.length % 4) % 4);
    const payload = atob(padded);
    const parts = payload.split('|');
    if (parts.length < 3) return null;
    return {
      tenantId: parts[0],
      customerId: parts[1],
      expiry: parseInt(parts[2], 10),
      customerName: parts.length >= 6 && parts[5] ? parts[5] : null,
    };
  } catch {
    return null;
  }
}
